export const insertOneTrustCookie = (key?: string) => {
  if (!key || process.env.REACT_APP_ENV !== 'production') {
    return;
  }
  (function (w: Window, d: Document, i: string) {
    const head = d.getElementsByTagName('head')[0];
    const script = d.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.async = true;
    script.setAttribute('data-domain-script', key);
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

    const optInScript = d.createElement('script');
    const optInFunction = d.createTextNode('function OptanonWrapper() { } ');

    optInScript.appendChild(optInFunction);
    head?.appendChild(script);
    head?.appendChild(optInScript);
  })(window, document, key);
};
